import React, { ReactNode } from 'react';
import { PlatformTypes } from '@om-fe/utils';
import { BemModifiersMap } from '@om-fe/core/core/types';
import TimeRangeNavItem from './time-range-nav-item';
import { Slider } from '@om-fe/widgets/dist/components/slider/slider';
import { CounterType, DisciplineLiveStatus } from '@om-fe/models';
import { TimeRangeListItemModel } from './time-range-nav.reducer';

export interface TopBetTimeRangeNavPublicProps {
    readonly disciplineId: string;
    readonly selectedId?: string;
    readonly instanceId: string;
    readonly counterType?: CounterType.numberOfLiveEvents;
    readonly liveStatus?: DisciplineLiveStatus;
    readonly locationId?: string;
    readonly categoryId?: string;
    readonly activeTab?: string;
    readonly preventRedirect?: boolean;
    readonly noRedirectFilter?: (item?: string) => void;
    readonly genericId?: string;
    readonly items?: Record<string, TimeRangeListItemModel>;
}

interface TopBetTimeRangeNavStoreProps {
    readonly list: string[];
    readonly ready?: boolean;
    readonly deviceType?: PlatformTypes;
    readonly lang?: string;
}

export type TopBetProps = TopBetTimeRangeNavPublicProps & TopBetTimeRangeNavStoreProps;

function TimeRangeNav ({
    deviceType, 
    list,
    activeTab,
    preventRedirect,
    noRedirectFilter,
    instanceId,
    items,
}: TopBetProps) {
    let timeRangeList: ReactNode[] = [];

    if (list.length > 0) {
        timeRangeList = list.map((id: string) => {
            const timeRangeName: string = items && items[id] ? items[id].displayName.replace(' ', '_') : id;

            return (
                <TimeRangeNavItem
                    instanceId={instanceId}
                    key={id}
                    id={id}
                    activeTab={activeTab}
                    preventRedirect={preventRedirect}
                    noRedirectFilter={noRedirectFilter}
                    extraClassName={`TimeRange--${timeRangeName}`}
                />
            )
        })
    }

    const modifiers: BemModifiersMap = {
        TimeRangeNav: true,
        ItemToStartUnequalWidth: true,
        Small10: true,
        Tertiary: true,
    };

    return (
        <Slider
            sliderItems={timeRangeList}
            modifiersFromParent={modifiers}
            hasArrows={deviceType === 'desktop'}
        />
    );
}

export default TimeRangeNav;
